import {Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy} from '@angular/core';
import {UsersService} from 'src/app/modules/shared/services/users.service';
import {Constants} from 'src/app/modules/shared/config/constants.config';
import {ThemeService} from '../../../shared/services/theme.service';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {Router} from '@angular/router';
import {MasterService} from '../../../shared/services/master.service';
import {DiaryChatMessage, DiaryChatMessages} from '../../../shared/viewModels/diary.viewModel';
import * as moment from 'moment';
import {UserProfileViewModel} from '../../../shared/viewModels/userProfile.viewModel';

@Component({
    selector: 'app-master-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardComponent implements OnInit {
    profiles_count = 0;
    messages: DiaryChatMessage[];
    notReadyUsers: UserProfileViewModel[];

    constructor(
        public readonly usersService: UsersService,
        public readonly masterService: MasterService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        public readonly themeService: ThemeService,
        public readonly constants: Constants,
        public readonly router: Router,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter
    ) {
    }

    ngOnInit() {
        this.masterService.getProfilesCount().subscribe(count => {
            this.profiles_count = count.count;
            this.changeDetectorRef.markForCheck();

        });

        this.masterService.getUnSeenMessages().subscribe(messages => {
            this.messages = messages.messages;
            this.changeDetectorRef.markForCheck();
        });

        this.masterService.getMasterNotReadyProfile().subscribe(notReadyUsers => {
            this.notReadyUsers = notReadyUsers;
            this.changeDetectorRef.markForCheck();
        });
    }

    formatCreatedTime(date) {
        return moment(date).format('HH:mm ч. / DD.MM.YYYY');
    }

    trim(message) {
        if (message.length > 150) {
            return message.substring(0, 150) + ' ....';
        }

        return message;
    }
}
